import React, { useContext, useEffect } from "react";
import moment from "moment";
import { navigate } from "@reach/router";
import useBranch from "../hooks/useBranch";
import useTrialClass from "../hooks/useTrialClass";
import { AuthContext } from "../context/AuthContext";
import { PackagesContext } from "../context/PackageContext";
import PaqueteCard from "../components/paquetes/PaquetesCard";
import { PurchasesContext } from "../context/PurchasesContext";

const Shop = () => {
  const { user } = useContext(AuthContext);
  const { trial_class_package } = useTrialClass();
  const { paquetes, getPaquetes } = useContext(PackagesContext);
  const { purchases, getPurchases } = useContext(PurchasesContext);
  const { branch, branchInterceptor, branches, selectBranch } = useBranch();

  useEffect(() => {
    getPaquetes();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [branchInterceptor, branch]);

  useEffect(() => {
    if (user && user !== null) {
      getPurchases();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  useEffect(() => {
    if (Array.isArray(paquetes)) {
      handleURLParams();
    }
  }, [paquetes]);

  const handleURLParams = () => {
    const elementId = window.location.hash.slice(1);
    if (elementId && elementId !== null) {
      const nodeElement = document.getElementById(elementId);
      if (nodeElement && nodeElement !== null) {
        nodeElement.scrollIntoView();
      }
    }
  };

  const hasOffers = () => {
    if (Array.isArray(paquetes)) {
      const salePackages = paquetes.filter(
        (class_package) => !isNaN(class_package.sale_price)
      );
      if (salePackages.length > 0) {
        return (
          <a href="#sale" className="btn bold btn-danger">
            OFERTAS
          </a>
        );
      }
    }
  };

  const renderSingleClass = () => {
    if (Array.isArray(paquetes)) {
      let paquetesRender = paquetes.filter(
        (paquete) => paquete.class_amount === 1
      );
      if (paquetesRender.length === 0) {
        return <p>No hay paquetes disponibles.</p>;
      }
      if (user && user !== null) {
        if (Array.isArray(purchases) && trial_class_package) {
          const index = purchases.findIndex(
            (purchase) =>
              purchase.class_package_id === trial_class_package.class_package_id
          );
          if (index !== -1) {
            paquetesRender = paquetesRender.filter(
              (paquete) =>
                paquete.class_package_id ===
                trial_class_package.class_package_id
            );
          }
        }
      }
      paquetesRender = paquetesRender.sort((a, b) => {
        if (a.is_special_event && !b.is_special_event) return -1;
        if (!a.is_special_event && b.is_special_event) return 1;
        const aHasIlimitado = String(a.title || "").toLowerCase().includes("ilimitado");
        const bHasIlimitado = String(b.title || "").toLowerCase().includes("ilimitado");
        if (aHasIlimitado && !bHasIlimitado) return 1;
        if (!aHasIlimitado && bHasIlimitado) return -1;
        return a.price - b.price;
      });
      return paquetesRender.map((paquete) => (
        <PaqueteCard
          key={paquete.class_package_id}
          paquete={paquete}
          className="btn btn-primary bold btn-block w-100"
          action={() => {
            navigate(`/checkout/${paquete.class_package_id}`);
          }}
        />
      ));
    }
    return <div className="spinner-border mx-2" role="status"></div>;
  };

  const renderOnline = () => {
    if (paquetes && paquetes !== null) {
      let paquetesRender = paquetes
        .filter(
          (paquete) =>
            paquete.include_online &&
            !paquete.is_special_event &&
            paquete.class_amount === null &&
            paquete.expiration_days < 40
        )
        .sort((a, b) => {
          if (a.is_special_event && !b.is_special_event) return -1;
          if (!a.is_special_event && b.is_special_event) return 1;
          const aHasIlimitado = String(a.title || "").toLowerCase().includes("ilimitado");
          const bHasIlimitado = String(b.title || "").toLowerCase().includes("ilimitado");
          if (aHasIlimitado && !bHasIlimitado) return 1;
          if (!aHasIlimitado && bHasIlimitado) return -1;
          return moment(a.updatedAt).isAfter(b.updatedAt) ? 1 : -1;
        });
      if (paquetesRender.length === 0) {
        return <p>No hay paquetes disponibles.</p>;
      }
      return paquetesRender.map((paquete) => (
        <PaqueteCard
          key={paquete.class_package_id}
          paquete={paquete}
          action={() => {
            navigate(`/checkout/${paquete.class_package_id}`);
          }}
        />
      ));
    }
    return <div className="spinner-border mx-2" role="status"></div>;
  };

  const renderPresenciales = () => {
    if (paquetes && paquetes !== null) {
      let paquetesRender = paquetes.filter(
        (paquete) =>
          !paquete.is_special_event &&
          paquete.class_amount > 1 &&
          paquete.sale_price === null
      );
      paquetesRender = paquetesRender.sort((a, b) => {
        if (a.is_special_event && !b.is_special_event) return -1;
        if (!a.is_special_event && b.is_special_event) return 1;
        const aHasIlimitado = String(a.title || "").toLowerCase().includes("ilimitado");
        const bHasIlimitado = String(b.title || "").toLowerCase().includes("ilimitado");
        if (aHasIlimitado && !bHasIlimitado) return 1;
        if (!aHasIlimitado && bHasIlimitado) return -1;
        return a.class_amount < b.class_amount ? -1 : 1;
      });
      if (paquetesRender.length === 0) {
        return <p>No hay paquetes disponibles.</p>;
      }
      return paquetesRender.map((paquete) => (
        <PaqueteCard
          key={paquete.class_package_id}
          paquete={paquete}
          className="btn btn-primary bold btn-block w-100"
          action={() => {
            navigate(`/checkout/${paquete.class_package_id}`);
          }}
        />
      ));
    }
    return <div className="spinner-border mx-2" role="status"></div>;
  };

  const renderEspeciales = () => {
    if (paquetes && paquetes !== null) {
      const especiales = paquetes.filter((paquete) => paquete.is_special_event);
      if (especiales.length === 0) {
        return <p className="px-3">No hay paquetes disponibles.</p>;
      }
      return especiales.map((especial) => (
        <PaqueteCard
          key={especial.class_package_id}
          paquete={especial}
          action={() => {
            navigate(`/checkout/${especial.class_package_id}`);
          }}
        />
      ));
    }
    return <div className="spinner-border"></div>;
  };

  const renderSale = (period, name) => {
    if (Array.isArray(paquetes)) {
      let paquetesRender = [...paquetes];
      if (!period && !name) {
        paquetesRender = paquetesRender.filter(
          ({ sale_price, subscription_period, subscription_interval }) =>
            sale_price !== null &&
            subscription_period === null &&
            subscription_interval === null
        );
      } else {
        if (isNaN(period)) {
          if (period === "year") {
            paquetesRender = paquetesRender
              .filter(
                ({ title, subscription_period, subscription_interval }) =>
                  subscription_period === period ||
                  subscription_interval === 365 ||
                  String(title).toLowerCase().includes("anual")
              )
              .sort((a, b) => {
                if (a.is_special_event && !b.is_special_event) return -1;
                if (!a.is_special_event && b.is_special_event) return 1;
                const aHasIlimitado = String(a.title || "").toLowerCase().includes("ilimitado");
                const bHasIlimitado = String(b.title || "").toLowerCase().includes("ilimitado");
                if (aHasIlimitado && !bHasIlimitado) return 1;
                if (!aHasIlimitado && bHasIlimitado) return -1;
                return a.class_amount - b.class_amount;
              });
          } else {
            paquetesRender = paquetesRender
              .filter(
                ({ subscription_period }) => subscription_period === period
              )
              .sort((a, b) => {
                if (a.is_special_event && !b.is_special_event) return -1;
                if (!a.is_special_event && b.is_special_event) return 1;
                const aHasIlimitado = String(a.title || "").toLowerCase().includes("ilimitado");
                const bHasIlimitado = String(b.title || "").toLowerCase().includes("ilimitado");
                if (aHasIlimitado && !bHasIlimitado) return 1;
                if (!aHasIlimitado && bHasIlimitado) return -1;
                return a.class_amount - b.class_amount;
              });
          }
        } else {
          if (period === 3) {
            paquetesRender = paquetesRender
              .filter(
                ({ title, subscription_interval }) =>
                  parseInt(subscription_interval) === parseInt(period) ||
                  parseInt(subscription_interval) === 120 ||
                  String(title).toLowerCase().includes("trimestral")
              )
              .sort((a, b) => {
                if (a.is_special_event && !b.is_special_event) return -1;
                if (!a.is_special_event && b.is_special_event) return 1;
                const aHasIlimitado = String(a.title || "").toLowerCase().includes("ilimitado");
                const bHasIlimitado = String(b.title || "").toLowerCase().includes("ilimitado");
                if (aHasIlimitado && !bHasIlimitado) return 1;
                if (!aHasIlimitado && bHasIlimitado) return -1;
                return a.class_amount - b.class_amount;
              });
          } else if (period === 6) {
            paquetesRender = paquetesRender
              .filter(
                ({ title, subscription_interval }) =>
                  parseInt(subscription_interval) === parseInt(period) ||
                  parseInt(subscription_interval) === 180 ||
                  parseInt(subscription_interval) === 240 ||
                  String(title).toLowerCase().includes("semestral")
              )
              .sort((a, b) => {
                if (a.is_special_event && !b.is_special_event) return -1;
                if (!a.is_special_event && b.is_special_event) return 1;
                const aHasIlimitado = String(a.title || "").toLowerCase().includes("ilimitado");
                const bHasIlimitado = String(b.title || "").toLowerCase().includes("ilimitado");
                if (aHasIlimitado && !bHasIlimitado) return 1;
                if (!aHasIlimitado && bHasIlimitado) return -1;
                return a.class_amount - b.class_amount;
              });
          } else {
            paquetesRender = paquetesRender
              .filter(
                ({ subscription_interval }) =>
                  parseInt(subscription_interval) === parseInt(period)
              )
              .sort((a, b) => {
                if (a.is_special_event && !b.is_special_event) return -1;
                if (!a.is_special_event && b.is_special_event) return 1;
                const aHasIlimitado = String(a.title || "").toLowerCase().includes("ilimitado");
                const bHasIlimitado = String(b.title || "").toLowerCase().includes("ilimitado");
                if (aHasIlimitado && !bHasIlimitado) return 1;
                if (!aHasIlimitado && bHasIlimitado) return -1;
                return a.class_amount - b.class_amount;
              });
          }
        }
      }
      if (paquetesRender.length > 0) {
        return (
          <div className="container-fluid">
            <h2 id="sale" className="row pb-3 border-bottom mt-5">
              TBM {name ? name : "SALE"}
            </h2>
            <div className="row">
              {paquetesRender.map((paquete) => (
                <PaqueteCard
                  key={paquete.class_package_id}
                  paquete={paquete}
                  className="btn btn-primary bold btn-block w-100"
                  action={() => {
                    navigate(`/checkout/${paquete.class_package_id}`);
                  }}
                />
              ))}
            </div>
          </div>
        );
      }
    }
  };

  const renderBranches = () => {
    if (Array.isArray(branches)) {
      return (
        <div className="btn-group w-100 my-3">
          {branches.map((currentBranch) => (
            <button
              onClick={() => selectBranch(currentBranch.branch_id)}
              className={`btn btn-${
                branch !== null && branch.branch_id === currentBranch.branch_id
                  ? "primary"
                  : "outline-primary"
              }`}
            >
              {currentBranch.name}
            </button>
          ))}
        </div>
      );
    }
  };

  return (
    <div className="container-fluid px-0 px-md-3">
      {renderBranches()}
      <div id="online" className="pb-2 align-items-center">
        <h2 className="mb-0">TBM Online</h2>
      </div>
      <div className="row online-bg py-5 px-3 align-items-center">
        {renderOnline()}
      </div>
      <div className="row my-3 pb-3 mb-0 align-items-center">
        <div className="col-8 col-md-6">
          <h2 className="mb-0">TBM Presencial</h2>
        </div>
        <div className="col-4 col-md-6 text-end">{hasOffers()}</div>
      </div>
      <div
        id="presenciales"
        className="row px-3 presencial-bg align-items-center"
      >
        {renderSingleClass()}
      </div>
      <h2 className="pb-2 my-3 border-bottom">TBM Presencial + TBM Online</h2>
      <div className="row mx-0">{renderPresenciales()}</div>
      {renderSale()}
      {renderSale(3, "Trimestral")}
      {renderSale(6, "Semestral")}
      {renderSale("year", "Anual")}
      <h2 className="pb-2 border-bottom m-3 mt-0">Paquetes Especiales</h2>
      <div className="row mx-0">{renderEspeciales()}</div>
    </div>
  );
};

export default Shop;
